import React, {useEffect, useState} from "react";
import { useCore } from "../hooks";
import { OrderItemListRow } from "./OrderItemListRow.tsx";
import { Btn } from "./Btn.tsx";
import {OrderItem, Voucher} from "depoto-core";
import { updateBill } from "../utils";

export const OrderItemList: React.FC = () => {
  const { currentOrder, setCurrentOrder } = useCore()
  const [oItems, setOItems] = useState<OrderItem[]>([])
  const removePercentageSale = (sale: Partial<Voucher>) => {
    const nextPercentageSales = [...(currentOrder.percentageSales || [])].filter(os => os.name !== sale.name && os.code !== sale.code)
    currentOrder.percentageSales = nextPercentageSales
    // todo remove from vouchers by id!!!!!!!!!!!!!!!!!!!!                      [ ]
    // todo orderFinalSummary - reflect percentual sales!!                      [ ]
    // todo updateBill is now fucking mess with percentual sales - refucktor    [x] DONE
    // todo modal voucher search: check validity..                              [ ]
    updateBill({ currentOrder, setCurrentOrder })
  }

  useEffect(() => {
    if (currentOrder?.items?.length) {
      const nextOItems = [...currentOrder.items]
      nextOItems.reverse()
      setOItems(nextOItems)
    } else {
      setOItems([])
    }
  }, [currentOrder])

  return (
    <div className="w-full">
      {oItems?.length > 0 ? (
        oItems.map(orderItem => <OrderItemListRow orderItem={orderItem} key={`orderItem-${orderItem.uuid}`} />)
      ) : null}
      {currentOrder?.percentageSales?.length > 0 ? currentOrder.percentageSales.map(os => (
        <div className="w-full flex flex-col order-item-list-row bg-white p-2 h-row border-1 boder-solid border-border-light mb-1">
          <div className="flex flex-row items-center w-full">
            <div className="font-bold">{os.name}</div>
            <div className="font-bold">{os.discountPercent}%</div>
            <div className="order-item-list-end">
              <Btn icon="far fa-trash-can" onClick={() => removePercentageSale(os)} className="btn-link btn-error" />
            </div>
          </div>
        </div>
      )) : null}
    </div>
  )
}
